export default __webpack_public_path__ + "static/media/red-2.6ec47097.png";